import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import MuiTooltip, { TooltipProps } from '@material-ui/core/Tooltip'

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    fontWeight: 600,
    fontSize: '0.929rem',
    padding: theme.spacing(1, 3)
  },
  arrow: {}
}))(MuiTooltip)

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[900],
    boxShadow: theme.shadows[5]
  },
  arrow: {
    color: theme.palette.grey[100]
  }
}))(StyledTooltip)

const Tooltip: React.FC<TooltipProps & { light?: boolean }> = ({ light, ...props }) => {
  const TooltipComponent = light !== undefined && light ? LightTooltip : StyledTooltip

  return <TooltipComponent arrow placement='top' {...props} />
}

export default Tooltip
